/**
 * Whether a settled thunk response was overtaken by a newer request of the
 * same kind, whose id the slice records on `pending`. Only the latest request's
 * response may land, so a response for the workspace or filters the user just
 * left never overwrites the current view. A null id means nothing claimed the
 * sequence, which keeps a directly dispatched action working.
 */
export const isSupersededResponse = (latestRequestId, action) =>
  latestRequestId != null && action.meta?.requestId !== latestRequestId;
